/* PrimeLux theme JS — vanilla, no dependencies, ~deferred. */
(function () {
  'use strict';

  var PL = window.PrimeLux || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function announce(msg) {
    var live = $('[data-live-region]');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 50);
  }

  /* ------------------------------------------------------------------
     Money formatting (mirrors Shopify money_format placeholders)
  ------------------------------------------------------------------ */
  // Real saving percent (mirrors snippets/pl-save-badge): rounded, 0 when compare <= price or the saving is under 1%.
  function savePercent(compare, price) {
    var c = Number(compare) || 0, p = Number(price) || 0;
    if (!(c > p) || c <= 0 || p < 0) return 0;
    var raw = (c - p) * 100 / c;
    return raw >= 1 ? Math.round(raw) : 0;
  }
  function saveLabel(pct) {
    return String((PL.strings && PL.strings.savePercent) || 'Save [percent]%').replace('[percent]', pct);
  }
  function setSaveBadge(el, compare, price) {
    if (!el) return;
    var pct = savePercent(compare, price);
    el.textContent = pct ? saveLabel(pct) : '';
    el.hidden = !pct;
  }
  function formatMoney(cents) {
    // Uses the shop's money_format (passed from layout/theme.liquid) so JS prices match the Liquid `money` filter.
    var format = String(PL.moneyFormat || 'R {{amount}}').replace(/<[^>]*>/g, '');
    if (typeof cents === 'string') cents = cents.indexOf('.') > -1 ? Math.round(parseFloat(cents) * 100) : parseInt(cents, 10);
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ------------------------------------------------------------------
     Drawers / modals (menu, search, cart, filters)
     Focus trap, Esc to close, focus return, scroll lock, ARIA state.
  ------------------------------------------------------------------ */
  var overlay = $('[data-overlay]');
  var activeDrawer = null;
  var lastTrigger = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getDrawer(name) { return $('[data-drawer="' + name + '"]'); }

  function setTriggers(name, expanded) {
    $$('[data-drawer-open="' + name + '"]').forEach(function (t) { t.setAttribute('aria-expanded', expanded ? 'true' : 'false'); });
  }

  function openDrawer(name, trigger) {
    var el = getDrawer(name);
    if (!el) return false;
    if (activeDrawer && activeDrawer !== el) closeDrawer(true);
    lastTrigger = trigger || document.activeElement;
    el.hidden = false;
    if (el.hasAttribute('data-drawer-persistent')) { el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); }
    // force reflow so the transition runs
    void el.offsetWidth;
    el.classList.add('is-open');
    if (overlay) { overlay.hidden = false; void overlay.offsetWidth; overlay.classList.add('is-visible'); }
    document.body.classList.add('is-locked', 'drawer-' + name + '-open');
    setTriggers(name, true);
    activeDrawer = el;
    var focusTarget = $('[data-predictive-input]', el) || $(FOCUSABLE, el);
    window.setTimeout(function () { if (focusTarget) focusTarget.focus({ preventScroll: true }); }, reduceMotion ? 0 : 60);
    return true;
  }

  function closeDrawer(skipFocus) {
    var el = activeDrawer;
    if (!el) return;
    var name = el.getAttribute('data-drawer');
    el.classList.remove('is-open');
    if (el.hasAttribute('data-drawer-persistent')) { el.removeAttribute('role'); el.removeAttribute('aria-modal'); }
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('is-locked', 'drawer-' + name + '-open');
    setTriggers(name, false);
    activeDrawer = null;
    var delay = reduceMotion ? 0 : 450;
    window.setTimeout(function () {
      if (!el.classList.contains('is-open') && !el.hasAttribute('data-drawer-persistent')) el.hidden = true;
      if (overlay && !activeDrawer) overlay.hidden = true;
    }, delay);
    if (!skipFocus && lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var name = opener.getAttribute('data-drawer-open');
      if (name === 'cart' && PL.cartType !== 'drawer') return;
      if (openDrawer(name, opener)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!activeDrawer) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key === 'Tab') {
      var items = $$(FOCUSABLE, activeDrawer).filter(function (n) { return n.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Desktop mega menu (sections/header).
     Mouse/trackpad ((hover:hover) and (pointer:fine)): hover opens after 80ms (200ms when switching from another open
     panel, so a diagonal path over a neighbour doesn't steal the panel); it closes only after the pointer has been
     outside BOTH the trigger and the panel for 300ms. An invisible bridge covers the gap down to the panel.
     Clicking the top-level label is a normal link: it navigates and never closes the panel first.
     Touch: first tap on the label opens, second tap navigates; tapping outside closes.
     Keyboard: focusing the label opens; the chevron button toggles (aria-expanded); ArrowDown enters; Esc closes.
     Also keeps --header-h = real header height and compacts nav spacing if it would need a 3rd row. */
  var desktopMQ = window.matchMedia('(min-width: 990px)');
  var finePointerMQ = window.matchMedia('(hover: hover) and (pointer: fine)');
  function initDropdowns(ctx) {
    $$('[data-mega-nav]', ctx).forEach(function (nav) {
      if (nav.dataset.bound) return; nav.dataset.bound = '1';
      var list = $('.header__nav-list', nav);
      var header = nav.closest('[data-header]');
      var OPEN_DELAY = 80, SWITCH_DELAY = 200, CLOSE_DELAY = 300;
      var current = null, mode = '', openTimer = 0, closeTimer = 0, quiet = false;

      function setExpanded(li, on) {
        $$('[data-mega-toggle]', li).forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      }
      function close(li) {
        li = li || current; if (!li) return;
        clearTimeout(openTimer); clearTimeout(closeTimer);
        li.classList.remove('is-open'); setExpanded(li, false);
        if (li === current) { current = null; mode = ''; }
      }
      function open(li, how) {
        clearTimeout(openTimer); clearTimeout(closeTimer);
        if (current && current !== li) close(current);
        li.classList.add('is-open'); setExpanded(li, true);
        current = li; mode = how;
        // hover bridge: from the bottom of this trigger down to the top of the panel (covers padding / a 2nd row)
        var trig = $('.header__nav-trigger', li), panel = $('[data-mega-panel]', li);
        if (trig && panel) {
          var gap = panel.getBoundingClientRect().top - trig.getBoundingClientRect().bottom;
          li.style.setProperty('--pl-bridge', Math.max(0, Math.ceil(gap) + 2) + 'px');
        }
      }
      function hoverable(e) { return e.pointerType === 'mouse' && finePointerMQ.matches && desktopMQ.matches; }

      $$('[data-mega-item]', nav).forEach(function (li) {
        var label = $('[data-mega-label]', li);
        var lastPointer = 'mouse';

        li.addEventListener('pointerenter', function (e) {
          if (!hoverable(e)) return;
          clearTimeout(closeTimer);
          if (current === li) return;
          clearTimeout(openTimer);
          openTimer = setTimeout(function () { open(li, 'hover'); }, current ? SWITCH_DELAY : OPEN_DELAY);
        });
        li.addEventListener('pointerleave', function (e) {
          if (!hoverable(e)) return;
          clearTimeout(openTimer);
          if (current !== li || mode === 'toggle' || (mode === 'focus' && li.contains(document.activeElement))) return;
          clearTimeout(closeTimer);
          closeTimer = setTimeout(function () { if (current === li && !li.matches(':hover')) close(li); }, CLOSE_DELAY);
        });

        if (label) {
          label.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; });
          if (label.tagName === 'A') {
            label.addEventListener('click', function (e) {
              // Mouse / keyboard: plain navigation. Touch & pen: first tap opens the panel, second tap navigates.
              if (lastPointer !== 'mouse' && e.detail !== 0 && desktopMQ.matches && current !== li) {
                e.preventDefault();
                open(li, 'tap');
              }
              lastPointer = 'mouse';
            });
          }
          label.addEventListener('focus', function () {
            if (!quiet && current !== li && desktopMQ.matches && label.matches(':focus-visible')) open(li, 'focus');
          });
        }

        $$('[data-mega-toggle]', li).forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            clearTimeout(openTimer);
            if (current === li && mode !== 'hover') close(li);
            else open(li, 'toggle');
          });
        });

        li.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowDown' || !e.target.closest('.header__nav-trigger')) return;
          e.preventDefault();
          open(li, 'toggle');
          var first = $('[data-mega-panel] a:not([tabindex="-1"])', li);
          if (first) first.focus();
        });
        li.addEventListener('focusout', function (e) {
          if (current !== li || mode === 'hover' || li.contains(e.relatedTarget)) return;
          if (!e.relatedTarget && li.matches(':hover')) return; // clicked a non-focusable spot inside the panel
          close(li);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !current) return;
        var li = current, hadFocus = li.contains(document.activeElement);
        close(li);
        var back = $('.header__nav-toggle', li) || $('[data-mega-label]', li);
        if (hadFocus && back) { quiet = true; back.focus(); quiet = false; }
      });
      document.addEventListener('click', function (e) {
        if (current && !current.contains(e.target)) close();
      });

      function rows() {
        var tops = {};
        $$('.header__nav-item', list).forEach(function (li) { tops[li.offsetTop] = 1; });
        return Object.keys(tops).length;
      }
      function setHeaderH() {
        var root = document.documentElement;
        root.style.removeProperty('--header-h');
        if (!desktopMQ.matches || !header) return;
        var css = parseFloat(getComputedStyle(root).getPropertyValue('--header-h')) || 0;
        var h = header.offsetHeight;
        if (h && Math.abs(h - css) > 1) root.style.setProperty('--header-h', h + 'px');
      }
      function fit() {
        nav.classList.remove('is-compact', 'is-tight', 'is-wrapped');
        if (desktopMQ.matches && list) {
          var r = rows();
          if (r > 2) { nav.classList.add('is-compact'); r = rows(); }
          if (r > 2) { nav.classList.add('is-tight'); r = rows(); }
          if (r > 1) nav.classList.add('is-wrapped');
        } else if (current) close();
        setHeaderH();
      }
      var raf = 0;
      window.addEventListener('resize', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(fit); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
      fit();
    });
  }

  /* Header shadow on scroll */
  var header = $('[data-header]');
  if (header) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      window.requestAnimationFrame(function () { header.classList.toggle('is-scrolled', window.scrollY > 10); ticking = false; });
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     Announcement rotation (pauses on hover/focus; off for reduced motion)
  ------------------------------------------------------------------ */
  function initAnnouncements() {
    $$('[data-announcement][data-rotate]').forEach(function (bar) {
      if (bar.dataset.bound || reduceMotion) return; bar.dataset.bound = '1';
      var msgs = $$('.announcement__msg', bar);
      if (msgs.length < 2) return;
      var i = 0, paused = false;
      var ms = (parseInt(bar.dataset.rotate, 10) || 6) * 1000;
      ['mouseenter', 'focusin'].forEach(function (ev) { bar.addEventListener(ev, function () { paused = true; }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { bar.addEventListener(ev, function () { paused = false; }); });
      window.setInterval(function () {
        if (paused || document.hidden) return;
        msgs = $$('.announcement__msg', bar); // campaign message may be removed once it ends
        if (msgs.length < 2) return;
        var cur = msgs.findIndex(function (m) { return m.classList.contains('is-active'); });
        if (cur > -1) { msgs[cur].classList.remove('is-active'); msgs[cur].setAttribute('aria-hidden', 'true'); }
        i = (cur + 1) % msgs.length;
        msgs[i].classList.add('is-active'); msgs[i].removeAttribute('aria-hidden');
      }, ms);
    });
  }

  /* ------------------------------------------------------------------
     Predictive search (native Shopify endpoint + section rendering)
  ------------------------------------------------------------------ */
  var searchInput = $('[data-predictive-input]');
  var searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults && PL.routes && PL.routes.predictiveSearch) {
    var timer, controller;
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      window.clearTimeout(timer);
      if (q.length < 2) { searchResults.innerHTML = ''; searchInput.setAttribute('aria-expanded', 'false'); return; }
      timer = window.setTimeout(function () {
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        var url = PL.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,article,query&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('#PredictiveSearchInner');
            searchResults.innerHTML = inner ? inner.outerHTML : '';
            searchInput.setAttribute('aria-expanded', inner ? 'true' : 'false');
          })
          .catch(function () {});
      }, 250);
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var options = $$('[role="option"]', searchResults);
      if (!options.length) return;
      e.preventDefault();
      var idx = options.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; });
      if (idx > -1) options[idx].setAttribute('aria-selected', 'false');
      idx = e.key === 'ArrowDown' ? (idx + 1) % options.length : (idx - 1 + options.length) % options.length;
      options[idx].setAttribute('aria-selected', 'true');
      var link = $('a', options[idx]);
      if (link) { link.focus(); }
    });
  }

  /* ------------------------------------------------------------------
     Cart: AJAX add, drawer re-render via Section Rendering API
  ------------------------------------------------------------------ */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.hidden = !count;
      var visible = el.querySelector('[aria-hidden]');
      if (visible) visible.textContent = count;
    });
  }

  function renderCartSections(sections) {
    if (!sections) return false;
    var html = sections['cart-drawer'];
    if (!html) return false;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-inner]');
      var current = $('#CartDrawer-Inner');
      if (fresh && current) {
        current.replaceWith(fresh);
        updateCartCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
        initCampaign(fresh);
        initCartUpsell(fresh);
        return true;
      }
      // Drawer markup missing (e.g. first render) — inject the whole drawer
      var freshDrawer = doc.querySelector('[data-drawer="cart"]');
      if (freshDrawer && !getDrawer('cart')) {
        document.body.appendChild(freshDrawer);
        var inner = $('[data-cart-inner]', freshDrawer);
        if (inner) updateCartCount(parseInt(inner.getAttribute('data-item-count'), 10) || 0);
        initCampaign(freshDrawer);
        initCartUpsell(freshDrawer);
        return true;
      }
    } catch (err) { /* fall through */ }
    return false;
  }

  /* Open the cart drawer smoothly after an add; falls back to /cart when the drawer is unavailable */
  function openCartDrawer(trigger) {
    if (PL.cartType !== 'drawer') { window.location.href = PL.routes.cart; return; }
    var open = function () {
      var el = getDrawer('cart');
      if (!el) { window.location.href = PL.routes.cart; return; }
      if (activeDrawer === el) return;
      // Two frames so the un-hidden drawer paints off-canvas before it slides in
      el.hidden = false;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { openDrawer('cart', trigger); });
      });
    };
    if (getDrawer('cart')) open();
    else refreshCart().then(open);
  }


  /* v9: "Added to your bag" card with the added item's photo (variant image first, then product image) at the top of the cart drawer */
  function showAdded(item) {
    var inner = $('[data-cart-inner]'); if (!inner || !item) return;
    var old = $('.pl-added', inner); if (old) old.remove();
    var src = (item.featured_image && item.featured_image.url) || item.image || '';
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; };
    var card = document.createElement('div');
    card.className = 'pl-added'; card.setAttribute('role', 'status');
    var img = src ? '<img src="' + esc(src) + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160" width="64" height="64" alt="" class="pl-added__img">' : '';
    var vt = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="pl-added__var">' + esc(item.variant_title) + '</span>' : '';
    card.innerHTML = img + '<div class="pl-added__txt"><span class="pl-added__ok">\u2713 Added to your bag</span><strong class="pl-added__name">' + esc(item.product_title || item.title) + '</strong>' + vt + '</div>';
    var hd = $('.drawer__header', inner);
    if (hd && hd.nextSibling) inner.insertBefore(card, hd.nextSibling); else inner.insertBefore(card, inner.firstChild);
  }

  function refreshCart() {
    return fetch(PL.routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(renderCartSections)
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || PL.cartType !== 'drawer' || !window.fetch) return;
    e.preventDefault();
    var submitter = e.submitter || $('[data-add-button]', form);
    var buttons = $$('[data-add-button], [data-sticky-button]').filter(function (b) {
      return form.contains(b) || (form.id && b.getAttribute('form') === form.id);
    });
    if (submitter && buttons.indexOf(submitter) === -1) buttons.push(submitter);
    var errorBox = $('[data-form-error]', form);
    if (errorBox) errorBox.hidden = true;
    buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });

    var fd = new FormData(form);
    // pick up quantity inputs associated via the form attribute
    if (form.id) $$('input[form="' + form.id + '"]').forEach(function (i) { if (i.name) fd.set(i.name, i.value); });
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    var added = false;
    var onCartPage = !!$('[data-main-cart]');

    fetch(PL.routes.cartAdd + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = res.data.description || res.data.message || (PL.strings && PL.strings.error);
          if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; } else { announce(msg); }
          return;
        }
        added = true;
        if (onCartPage) { window.location.reload(); return; }
        announce(PL.strings && PL.strings.added);
        var addedItem = res.data.items ? res.data.items[0] : res.data;
        var trigger = $('[data-drawer-open="cart"]');
        if (renderCartSections(res.data.sections)) { showAdded(addedItem); openCartDrawer(trigger); }
        else { refreshCart().then(function () { showAdded(addedItem); openCartDrawer(trigger); }); }
      })
      .catch(function () {
        // Never double-add: only fall back to a native submit when the AJAX add itself failed
        if (added) window.location.href = PL.routes.cart; else form.submit();
      })
      .finally(function () { buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });
  });

  function changeLine(line, quantity, scopeEl) {
    var lineEl = scopeEl && scopeEl.closest('[data-cart-line]');
    if (lineEl) lineEl.classList.add('is-loading');
    var onCartPage = !!$('[data-main-cart]');
    var sections = onCartPage ? 'main-cart' : 'cart-drawer';
    // On the cart page we reload (keeps notes/upsell consistent with zero JS rendering logic)
    return fetch(PL.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: onCartPage ? [] : [sections], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { announce(data.description || PL.strings.error); if (lineEl) lineEl.classList.remove('is-loading'); return; }
        if (onCartPage) { window.location.reload(); return; }
        renderCartSections(data.sections);
        var inner = $('#CartDrawer-Inner');
        var focusEl = inner && ($('[data-cart-qty][data-line="' + line + '"]', inner) || $('.drawer__header button', inner));
        if (focusEl) focusEl.focus({ preventScroll: true });
      })
      .catch(function () { window.location.href = PL.routes.cart; });
  }

  // Quantity steppers (product + cart)
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-qty]');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var min = parseInt(input.min, 10) || 0;
    var val = (parseInt(input.value, 10) || 0) + (plus ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  var qtyTimer;
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    window.clearTimeout(qtyTimer);
    qtyTimer = window.setTimeout(function () {
      changeLine(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0), input);
    }, 350);
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(parseInt(remove.dataset.cartRemove, 10), 0, remove);
  });

  // Cart note (page) — save quietly
  document.addEventListener('change', function (e) {
    if (e.target.id !== 'CartNote') return;
    fetch(PL.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
  });

  // Address delete confirm
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-confirm]');
    if (btn && !window.confirm(btn.dataset.confirm)) e.preventDefault();
  });

  // Login ↔ recover toggle
  function toggleRecover(show) {
    var rec = $('#RecoverPassword'), login = $('#CustomerLogin');
    if (!rec || !login) return;
    rec.hidden = !show; login.hidden = show;
    var f = $('input', show ? rec : login); if (f) f.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle-recover]');
    if (!t) return; e.preventDefault();
    toggleRecover($('#RecoverPassword').hidden);
  });
  if (window.location.hash === '#recover' || $('[data-recover-success]')) toggleRecover(true);

  /* ------------------------------------------------------------------
     Product: variants, gallery, sticky ATC
  ------------------------------------------------------------------ */
  function initProduct(section) {
    if (section.dataset.bound) return; section.dataset.bound = '1';
    var jsonEl = $('[data-product-json]', section);
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var picker = $('[data-variant-picker]', section);
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('.product__buy [data-add-button]', section);
    var addLabel = addBtn && $('[data-add-label]', addBtn);
    var sticky = $('[data-sticky-atc]', section);
    var track = $('[data-gallery-track]', section);

    function goToMedia(mediaId, smooth) {
      if (!track || !mediaId) return;
      var slide = $('[data-media-id="' + mediaId + '"]', track);
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      setActiveThumb(mediaId);
    }
    function setActiveThumb(mediaId) {
      $$('[data-thumb]', section).forEach(function (t) {
        var on = t.dataset.thumb === String(mediaId);
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }

    $$('[data-thumb]', section).forEach(function (t) {
      t.addEventListener('click', function () { goToMedia(t.dataset.thumb, true); });
    });

    if (track && 'IntersectionObserver' in window) {
      var counter = $('[data-gallery-current]', section);
      var slides = $$('.gallery__slide', track);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) {
            var idx = slides.indexOf(en.target);
            if (counter) counter.textContent = idx + 1;
            setActiveThumb(en.target.dataset.mediaId);
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
      var active = $('.gallery__slide.is-active', track);
      if (active) goToMedia(active.dataset.mediaId, false);
    }

    if (picker && product) {
      picker.addEventListener('change', function (e) {
        var input = e.target.closest('[data-option-input]');
        if (input) {
          var label = input.closest('fieldset').querySelector('[data-option-selected]');
          if (label) label.textContent = input.value;
        }
        var selected = $$('fieldset', picker).map(function (fs) {
          var checked = $('input:checked', fs); return checked ? checked.value : null;
        });
        var variant = product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        updateVariant(variant);
      });
    }

    function atcText(el) {
      return (el && el.getAttribute('data-atc-label')) || (addBtn && addBtn.getAttribute('data-atc-label')) || (PL.strings && PL.strings.addToCart) || 'Add to cart';
    }

    function updateVariant(variant) {
      var strings = PL.strings || {};
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = strings.unavailable; }
        syncSticky(null);
        return;
      }
      if (idInput) idInput.value = variant.id;
      var priceWrap = $('[data-product-price]', section);
      if (priceWrap) {
        var cur = $('[data-price-current]', priceWrap), cmp = $('[data-price-compare]', priceWrap), box = $('[data-price]', priceWrap);
        // Product page always shows the selected variant — never a "From" range.
        if (cur) {
          var fromEl = cur.querySelector('.price__from');
          if (fromEl) fromEl.remove();
          cur.textContent = formatMoney(variant.price);
        }
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (cmp) {
          cmp.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
          cmp.hidden = !onSale;
        }
        if (box) box.classList.toggle('price--sale', !!onSale);
        setSaveBadge($('[data-save-badge]', priceWrap), variant.compare_at_price, variant.price);
        var saveAmt = $('[data-save-amount]', priceWrap);
        if (saveAmt) {
          var diff = onSale ? variant.compare_at_price - variant.price : 0;
          saveAmt.textContent = diff > 0 ? String((PL.strings && PL.strings.youSave) || 'You save [amount]').replace('[amount]', formatMoney(diff)) : '';
          saveAmt.hidden = !(diff > 0);
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? atcText(addBtn) : strings.soldOut;
      }
      if (variant.featured_media) goToMedia(variant.featured_media.id, true);
      syncSticky(variant);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function syncSticky(variant) {
      if (!sticky) return;
      var btn = $('[data-sticky-button]', sticky);
      var price = $('[data-sticky-price]', sticky);
      var vt = $('[data-sticky-variant]', sticky);
      var strings = PL.strings || {};
      if (!variant) { if (btn) { btn.disabled = true; btn.textContent = strings.unavailable; } return; }
      if (price) price.textContent = formatMoney(variant.price);
      setSaveBadge($('[data-sticky-save]', sticky), variant.compare_at_price, variant.price);
      var swas = $('[data-sticky-was]', sticky); if (swas) { var hasWas = variant.compare_at_price && variant.compare_at_price > variant.price; swas.hidden = !hasWas; if (hasWas) swas.textContent = formatMoney(variant.compare_at_price); }
      if (vt && product && product.variants.length > 1) vt.textContent = '· ' + variant.title;
      if (btn) { btn.disabled = !variant.available; btn.textContent = variant.available ? atcText(btn) : strings.soldOut; }
    }

    // Sticky ATC slides up once the MAIN Add to Cart button has scrolled above the viewport (under the sticky header),
    // and slides away again when the button is back in view or the footer is reached.
    var mainBtn = $('[data-main-atc-button]', section) || $('.product__buy [data-add-button]', section) || $('[data-main-atc]', section);
    if (sticky && mainBtn) {
      var footerEl = $('.footer');
      var headerOffset = function () {
        var h = $('.section-header');
        if (!h) return 0;
        var cs = window.getComputedStyle(h);
        return cs.position === 'sticky' || cs.position === 'fixed' ? h.getBoundingClientRect().height : 0;
      };
      var shown = null;
      // Draft previews inject Shopify's fixed preview bar at the bottom of the viewport; lift the bar above it.
      var pbarH = function () {
        var pb = document.getElementById('PBarNextFrameWrapper');
        return pb && pb.getClientRects().length ? Math.round(pb.getBoundingClientRect().height) : 0;
      };
      var setShown = function (show) {
        document.documentElement.style.setProperty('--pl-pbar-h', pbarH() + 'px');
        if (show === shown) return;
        shown = show;
        sticky.classList.toggle('is-visible', show);
        // Reserve room at the bottom of the page for the bar so it never covers content/footer links.
        document.documentElement.style.setProperty('--sticky-atc-h', Math.ceil(sticky.getBoundingClientRect().height || 0) + 'px');
        document.body.classList.toggle('has-sticky-atc', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      };
      var evaluate = function () {
        var r = mainBtn.getBoundingClientRect();
        var passed = r.bottom < headerOffset() + 4; // button fully scrolled past (behind the header)
        // v5 mobile: the bar also shows while the main button is still below the first screen (Medicube-style
        // full-width gallery), so Add to cart is always one tap away.
        if (!passed && window.innerWidth < 750 && r.top > window.innerHeight - 8) passed = true;
        var nearFooter = false;
        if (footerEl) nearFooter = footerEl.getBoundingClientRect().top < window.innerHeight - 40;
        setShown(passed && !nearFooter && !mainBtn.closest('[hidden]'));
      };
      var ticking = false;
      var onScroll = function () {
        if (ticking) return; ticking = true;
        window.requestAnimationFrame(function () { ticking = false; evaluate(); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(onScroll, { threshold: [0, 1] }).observe(mainBtn);
        if (footerEl) new IntersectionObserver(onScroll, { threshold: [0] }).observe(footerEl);
      }
      evaluate();
    }
  }

  /* ------------------------------------------------------------------
     Product recommendations (complementary → related fallback)
  ------------------------------------------------------------------ */
  function initRecommendations(el) {
    if (el.dataset.bound || !el.dataset.url) return; el.dataset.bound = '1';
    var load = function (url) {
      return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-recommendations-inner]');
        return inner ? inner.outerHTML : '';
      });
    };
    var run = function () {
      load(el.dataset.url).then(function (html) {
        if (html) return html;
        return el.dataset.fallbackUrl ? load(el.dataset.fallbackUrl) : '';
      }).then(function (html) {
        if (html) { el.innerHTML = html; initReveal(el); } else if (!$('[data-recs-fallback]', el)) { el.hidden = true; }
      }).catch(function () { if (!$('[data-recs-fallback]', el)) el.hidden = true; });
    };
    // An empty section is display:none (.recs:empty) and would never intersect, so watch its wrapper instead.
    var target = el.getClientRects().length ? el : (el.parentElement || el);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); run(); } }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(target);
    } else { run(); }
  }

  /* ------------------------------------------------------------------
     Limited edit countdown — only runs against a real merchant-set date
  ------------------------------------------------------------------ */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      if (el.dataset.bound) return; el.dataset.bound = '1';
      var end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      var units = $('.countdown__units', el), ended = $('[data-cd-ended]', el);
      var out = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tick = function () {
        var diff = end - Date.now();
        if (diff <= 0) {
          if (units) units.hidden = true;
          if (ended) ended.hidden = false;
          window.clearInterval(timer);
          return;
        }
        var s = Math.floor(diff / 1000);
        out.d.textContent = pad(Math.floor(s / 86400));
        out.h.textContent = pad(Math.floor((s % 86400) / 3600));
        out.m.textContent = pad(Math.floor((s % 3600) / 60));
        out.s.textContent = pad(s % 60);
      };
      var timer = window.setInterval(tick, 1000);
      tick();
    });
  }

  /* ------------------------------------------------------------------
     Facets — auto-submit native GET form (no-JS works with the button)
  ------------------------------------------------------------------ */
  var facetTimer;
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-facet-autosubmit]');
    if (!el) return;
    var form = el.form || document.getElementById(el.getAttribute('form'));
    if (!form) return;
    // On mobile the drawer has an explicit "Show results" button
    if (activeDrawer && activeDrawer.contains(el)) return;
    window.clearTimeout(facetTimer);
    facetTimer = window.setTimeout(function () {
      // strip empty price params for clean URLs
      $$('input[type="number"]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
      form.submit();
    }, el.type === 'number' ? 700 : 150);
  });

  /* ------------------------------------------------------------------
     Reveal on scroll (respects reduced motion)
  ------------------------------------------------------------------ */
  // Fail-safe: CSS only hides .reveal under html.pl-reveal-on, which is added here once the observer is live.
  // No JS / a JS error / reduced motion / theme editor = everything simply visible.
  var revealObserver = null, revealTimer = null;
  function revealNow(el) { el.classList.add('is-revealed'); if (revealObserver) revealObserver.unobserve(el); }
  function revealSweep(all) {
    // Anything on screen or already scrolled past (incl. cards in sideways scrollers) is shown.
    $$('.reveal:not(.is-revealed)').forEach(function (el) {
      if (all || el.getBoundingClientRect().top < window.innerHeight) revealNow(el);
    });
  }
  function initReveal(ctx) {
    var items = $$('.reveal:not(.is-revealed)', ctx);
    if (!document.body.classList.contains('has-reveal') || reduceMotion || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      items.forEach(function (i) { i.classList.add('is-revealed'); });
      document.documentElement.classList.remove('pl-reveal-on');
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) revealNow(en.target); });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      var idle;
      window.addEventListener('scroll', function () { window.clearTimeout(idle); idle = window.setTimeout(revealSweep, 200); }, { passive: true });
      window.addEventListener('beforeprint', function () { revealSweep(true); });
    }
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-revealed'); // above the fold: no fade
      else revealObserver.observe(el);
    });
    document.documentElement.classList.add('pl-reveal-on');
    window.clearTimeout(revealTimer);
    revealTimer = window.setTimeout(revealSweep, 2500);
  }

  /* ------------------------------------------------------------------
     Lazy muted clips — play only when ~50% in view (no above-fold autoplay)
  ------------------------------------------------------------------ */
  function resolveLazyVideo(host) {
    if (!host) return null;
    if (host.tagName === 'VIDEO') return host;
    return host.querySelector('video');
  }

  function prepareLazyVideo(host) {
    var video = resolveLazyVideo(host);
    if (!video) return null;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.playsInline = true;
    video.loop = true;
    // Keep preload=none until first in-view play upgrade
    if (!video.dataset.plPreloadReady) {
      video.preload = 'none';
      video.setAttribute('preload', 'none');
    }
    var poster = host.getAttribute('data-pl-poster');
    if (poster && !video.getAttribute('poster')) video.setAttribute('poster', poster);
    return video;
  }

  function initLazyVideos(ctx) {
    var hosts = $$('[data-pl-lazy-video]', ctx);
    if (!hosts.length) return;

    if (reduceMotion) {
      hosts.forEach(function (host) {
        var video = prepareLazyVideo(host);
        if (!video) return;
        try { video.pause(); } catch (e) {}
        video.removeAttribute('autoplay');
        // Keep poster visible; do not load/play under reduced motion
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      hosts.forEach(function (host) {
        var video = prepareLazyVideo(host);
        if (!video) return;
        if (host.getAttribute('data-pl-autoplay') === 'true') {
          var play = video.play();
          if (play && play.catch) play.catch(function () {});
        }
      });
      return;
    }

    if (!window.__plLazyVideoIO) {
      window.__plLazyVideoIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var host = en.target;
          var video = prepareLazyVideo(host);
          if (!video) return;
          var shouldPlay = host.getAttribute('data-pl-autoplay') === 'true';
          if (en.isIntersecting && en.intersectionRatio >= 0.25) {
            if (shouldPlay) {
              // Fetch once ~25% of the clip is in view (more reliable than a strict 50% gate)
              video.dataset.plPreloadReady = '1';
              if (video.preload === 'none') {
                video.preload = 'metadata';
                video.setAttribute('preload', 'metadata');
              }
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else {
            try { video.pause(); } catch (e) {}
          }
        });
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    }

    hosts.forEach(function (host) {
      if (host.dataset.plLazyBound) return;
      host.dataset.plLazyBound = '1';
      prepareLazyVideo(host);
      window.__plLazyVideoIO.observe(host);
    });
  }


  /* ------------------------------------------------------------------
     Wishlist (customer metafields unavailable on storefront → localStorage)
  ------------------------------------------------------------------ */
  var WISH_KEY = 'pl_wishlist_v1';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function setWishlist(ids) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(ids)); } catch (e) {}
  }
  function syncWishlistUI(ctx) {
    var ids = getWishlist();
    $$('[data-wishlist-toggle]', ctx).forEach(function (btn) {
      var id = String(btn.getAttribute('data-product-id') || '');
      var on = ids.indexOf(id) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = $('[data-wish-label]', btn);
      if (label) label.textContent = on ? 'Saved' : 'Save to wishlist';
    });
  }
  function initWishlist(ctx) {
    syncWishlistUI(ctx);
    $$('[data-wishlist-toggle]', ctx).forEach(function (btn) {
      if (btn.dataset.wishBound) return; btn.dataset.wishBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = String(btn.getAttribute('data-product-id') || '');
        if (!id) return;
        var ids = getWishlist();
        var i = ids.indexOf(id);
        if (i === -1) ids.push(id); else ids.splice(i, 1);
        setWishlist(ids);
        syncWishlistUI(document);
        announce(i === -1 ? 'Saved to wishlist' : 'Removed from wishlist');
      });
    });
  }

  /* ------------------------------------------------------------------
     Recently viewed (localStorage) — product pages stamp themselves
  ------------------------------------------------------------------ */
  var VIEW_KEY = 'pl_recently_viewed_v1';
  function getRecentlyViewed() {
    try { return JSON.parse(localStorage.getItem(VIEW_KEY) || '[]'); } catch (e) { return []; }
  }
  function trackRecentlyViewed() {
    $$('[data-track-viewed]').forEach(function (el) {
      var handle = el.getAttribute('data-product-handle');
      var id = el.getAttribute('data-product-id');
      var url = el.getAttribute('data-product-url');
      if (!handle || !id) return;
      var list = getRecentlyViewed().filter(function (x) { return String(x.id) !== String(id); });
      list.unshift({ id: id, handle: handle, url: url });
      try { localStorage.setItem(VIEW_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
    });
  }

  // Recently viewed row: hidden unless this device has history; real cards fetched only near the viewport.
  function initRecentlyViewedRow(ctx) {
    $$('[data-recently-viewed]', ctx).forEach(function (el) {
      if (el.dataset.rvBound) return; el.dataset.rvBound = '1';
      var grid = $('[data-rv-grid]', el);
      if (!grid || !window.fetch || !window.DOMParser) return;
      var ex = String(el.getAttribute('data-exclude') || '');
      var list = getRecentlyViewed().filter(function (x) {
        return x && x.url && /^\/[^/]/.test(x.url) && String(x.id) !== ex;
      }).slice(0, parseInt(el.getAttribute('data-limit'), 10) || 4);
      if (!list.length) return;
      grid.innerHTML = list.map(function () { return '<li class="product-grid__item pl-rv__ph"><div class="ratio ratio--portrait"></div></li>'; }).join('');
      el.hidden = false;
      var items = $$('.product-grid__item', grid);
      var run = function () {
        list.forEach(function (x, i) {
          var li = items[i];
          var drop = function () { li.remove(); if (!grid.children.length) el.hidden = true; };
          fetch(x.url.split('?')[0] + '?section_id=pl-product-card')
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
            .then(function (html) {
              var card = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pl-card]');
              if (!card || !card.firstElementChild) return drop();
              li.className = 'product-grid__item';
              li.innerHTML = card.innerHTML;
              initReveal(li); initWishlist(li);
            })
            .catch(drop);
        });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); run(); } }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(el);
      } else { run(); }
    });
  }

  /* ------------------------------------------------------------------
     Bestsellers / product-grid carousel arrows
  ------------------------------------------------------------------ */
  function initCarousels(ctx) {
    $$('[data-bestsellers-carousel], [data-carousel-wrap]', ctx).forEach(function (root) {
      if (root.dataset.carouselBound) return; root.dataset.carouselBound = '1';
      var wrap = root.hasAttribute('data-carousel-wrap') ? root : $('[data-carousel-wrap]', root) || root;
      var track = $('[data-carousel-track], .product-grid--scroll', wrap) || $('.product-grid--scroll', root);
      var prev = $('[data-carousel-prev]', root);
      var next = $('[data-carousel-next]', root);
      if (!track || (!prev && !next)) return;
      var scrollBy = function (dir) {
        var amount = Math.max(track.clientWidth * 0.8, 240) * dir;
        track.scrollBy({ left: amount, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
      if (next) next.addEventListener('click', function () { scrollBy(1); });
    });
  }

  /* ------------------------------------------------------------------
     Before / after drag slider
  ------------------------------------------------------------------ */
  function initBeforeAfter(ctx) {
    // Markup: .ba__slider[data-ba] > .ba__after, .ba__before[data-ba-before], input.ba__range[data-ba-range], .ba__handle
    // Position lives in the CSS custom property --ba-pos on the slider (clip-path + handle both read it).
    // Mouse/pen/touch: pointer events with capture (touch-action: pan-y keeps vertical page scroll).
    // Keyboard: the native range input (arrows / Home / End / PageUp / PageDown).
    $$('[data-ba]', ctx).forEach(function (slider) {
      if (slider.dataset.baBound) return; slider.dataset.baBound = '1';
      var range = $('[data-ba-range]', slider);
      var setPos = function (pct) {
        pct = Math.max(0, Math.min(100, pct));
        slider.style.setProperty('--ba-pos', pct + '%');
        if (range) {
          range.value = String(Math.round(pct));
          range.setAttribute('aria-valuetext', Math.round(pct) + '% before');
        }
      };
      if (range) {
        range.addEventListener('input', function () { setPos(parseFloat(range.value)); });
        range.addEventListener('focus', function () { slider.classList.add('is-focused'); });
        range.addEventListener('blur', function () { slider.classList.remove('is-focused'); });
      }
      var dragging = false, pid = null;
      var fromX = function (clientX) {
        var rect = slider.getBoundingClientRect();
        if (!rect.width) return;
        setPos(((clientX - rect.left) / rect.width) * 100);
      };
      var onDown = function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true; pid = e.pointerId;
        slider.classList.add('is-dragging');
        try { slider.setPointerCapture(e.pointerId); } catch (err) {}
        fromX(e.clientX);
        if (e.pointerType === 'mouse') e.preventDefault(); // no text/image selection while dragging
      };
      var onMove = function (e) { if (dragging && (pid === null || e.pointerId === pid)) fromX(e.clientX); };
      var onUp = function (e) {
        if (!dragging) return;
        dragging = false;
        slider.classList.remove('is-dragging');
        try { slider.releasePointerCapture(e.pointerId); } catch (err) {}
      };
      if (window.PointerEvent) {
        slider.addEventListener('pointerdown', onDown);
        slider.addEventListener('pointermove', onMove);
        slider.addEventListener('pointerup', onUp);
        slider.addEventListener('pointercancel', onUp);
        slider.addEventListener('lostpointercapture', function () { dragging = false; slider.classList.remove('is-dragging'); });
      } else {
        // Very old browsers: mouse + touch fallback
        slider.addEventListener('mousedown', function (e) { dragging = true; fromX(e.clientX); e.preventDefault(); });
        window.addEventListener('mousemove', function (e) { if (dragging) fromX(e.clientX); });
        window.addEventListener('mouseup', function () { dragging = false; });
        slider.addEventListener('touchstart', function (e) { dragging = true; fromX(e.touches[0].clientX); }, { passive: true });
        slider.addEventListener('touchmove', function (e) { if (dragging) fromX(e.touches[0].clientX); }, { passive: true });
        slider.addEventListener('touchend', function () { dragging = false; });
      }
      slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
      setPos(range ? parseFloat(range.value) || 50 : 50);
      slider.classList.add('is-ready');
    });
  }

  /* ------------------------------------------------------------------
     Beauty quiz
  ------------------------------------------------------------------ */
  function initBeautyQuiz(ctx) {
    $$('[data-beauty-quiz]', ctx).forEach(function (root) {
      if (root.dataset.quizBound) return; root.dataset.quizBound = '1';
      var quiz = $('[data-quiz]', root);
      if (!quiz) return;
      var steps = $$('[data-quiz-step]', quiz);
      var result = $('[data-quiz-result]', quiz);
      var prevBtn = $('[data-quiz-prev]', quiz);
      var nextBtn = $('[data-quiz-next]', quiz);
      var progress = $('[data-quiz-progress]', quiz);
      var bar = $('[data-quiz-progress-bar]', quiz);
      var stepLabel = $('[data-quiz-step-label]', quiz);
      var outcomesEl = $('[data-quiz-outcomes]', root);
      var outcomes = { outcomes: [], fallbackUrl: '/' };
      try { outcomes = JSON.parse(outcomesEl.textContent || '{}'); } catch (e) {}
      var answers = {};
      var idx = 0;

      var updateProgress = function () {
        var total = steps.length + 1;
        var pct = ((idx + 1) / total) * 100;
        if (bar) bar.style.setProperty('--quiz-pct', pct + '%');
        if (progress) progress.setAttribute('aria-valuenow', String(Math.round(pct)));
        if (stepLabel) stepLabel.textContent = idx < steps.length ? ('Step ' + (idx + 1) + ' of ' + steps.length) : 'Your ritual';
      };

      var showStep = function () {
        steps.forEach(function (s, i) {
          var on = i === idx;
          s.hidden = !on;
          s.classList.toggle('is-active', on);
        });
        if (result) result.hidden = idx < steps.length;
        if (prevBtn) prevBtn.hidden = idx === 0;
        if (nextBtn) {
          nextBtn.hidden = idx >= steps.length;
          var current = steps[idx];
          var checked = current ? $('[data-quiz-answer]:checked', current) : null;
          nextBtn.disabled = idx < steps.length && !checked;
          nextBtn.textContent = idx === steps.length - 1 ? 'See my ritual' : 'Continue';
        }
        updateProgress();
      };

      var pickOutcome = function () {
        var tags = Object.keys(answers).map(function (k) { return answers[k]; });
        var best = null; var bestScore = 0;
        (outcomes.outcomes || []).forEach(function (o) {
          var match = String(o.match || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
          var score = 0;
          match.forEach(function (t) { if (tags.indexOf(t) !== -1) score += 1; });
          if (score > bestScore) { bestScore = score; best = o; }
        });
        return best;
      };

      var renderResult = function () {
        var o = pickOutcome();
        var title = $('[data-quiz-result-text]', quiz) || $('.quiz__result-text', quiz);
        var productsHost = $('[data-quiz-products]', quiz);
        var cta = $('[data-quiz-cta]', quiz);
        if (o) {
          var heading = $('.quiz__result-title', quiz);
          if (heading && o.title) heading.textContent = o.title;
          if (title) title.textContent = o.text || '';
          if (cta && o.url) cta.href = o.url;
          else if (cta && outcomes.fallbackUrl) cta.href = outcomes.fallbackUrl;
          if (productsHost) {
            productsHost.innerHTML = '';
            (o.products || []).forEach(function (p) {
              var a = document.createElement('a');
              a.className = 'quiz__result-card';
              a.href = p.url;
              a.innerHTML = (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy" width="72" height="90">' : '<span></span>') +
                '<span><strong>' + escapeHtml(p.title || '') + '</strong><span>' + escapeHtml(p.price || '') + '</span></span>';
              productsHost.appendChild(a);
            });
          }
        } else if (title) {
          title.textContent = title.textContent;
          if (cta && outcomes.fallbackUrl) cta.href = outcomes.fallbackUrl;
        }
      };

      quiz.addEventListener('change', function (e) {
        if (!e.target.matches('[data-quiz-answer]')) return;
        var step = e.target.closest('[data-quiz-step]');
        if (!step) return;
        answers[step.getAttribute('data-quiz-key') || step.getAttribute('data-quiz-step')] = e.target.getAttribute('data-quiz-tag') || e.target.value;
        if (nextBtn) nextBtn.disabled = false;
      });

      if (nextBtn) nextBtn.addEventListener('click', function () {
        if (idx < steps.length - 1) { idx += 1; showStep(); }
        else { idx = steps.length; renderResult(); showStep(); }
      });
      if (prevBtn) prevBtn.addEventListener('click', function () {
        if (idx > 0) { idx -= 1; showStep(); }
      });
      var restart = $('[data-quiz-restart]', quiz);
      if (restart) restart.addEventListener('click', function () {
        answers = {}; idx = 0;
        $$('[data-quiz-answer]', quiz).forEach(function (i) { i.checked = false; });
        showStep();
      });
      showStep();
    });
  }

  /* ------------------------------------------------------------------
     Popups — session storage, exit intent (desktop), welcome, cart reminder
  ------------------------------------------------------------------ */
  function initPopups(ctx) {
    $$('[data-popups]', ctx).forEach(function (root) {
      if (root.dataset.popBound) return; root.dataset.popBound = '1';
      var sessionKey = 'pl_popup_seen_' + (root.getAttribute('data-section-id') || 'x');
      // v4 frequency cap: a dismissed popup stays away for N days on this device (data-cap-days, default 7).
      var capMs = (parseInt(root.getAttribute('data-cap-days'), 10) || 7) * 864e5;
      var seen = {}, stamps = {};
      try { stamps = JSON.parse(localStorage.getItem(sessionKey) || '{}'); } catch (e) {}
      Object.keys(stamps).forEach(function (k) { if (Date.now() - stamps[k] < capMs) seen[k] = 1; });
      var mark = function (name) {
        seen[name] = 1; stamps[name] = Date.now();
        try { localStorage.setItem(sessionKey, JSON.stringify(stamps)); } catch (e) {}
      };
      var openPopup = function (name) {
        if (seen[name] || activeDrawer || $('[data-main-cart]')) return; // never over the cart / an open drawer
        var el = $('[data-popup="' + name + '"]', root);
        if (!el || el.classList.contains('is-open')) return;
        // close others
        $$('[data-popup]', root).forEach(function (p) {
          p.hidden = true; p.classList.remove('is-open');
        });
        el.hidden = false;
        void el.offsetWidth;
        el.classList.add('is-open');
        mark(name);
        var focusable = $(FOCUSABLE, el);
        if (focusable) window.setTimeout(function () { focusable.focus({ preventScroll: true }); }, reduceMotion ? 0 : 40);
      };
      var closePopup = function (el) {
        if (!el) return;
        el.classList.remove('is-open');
        window.setTimeout(function () { el.hidden = true; }, reduceMotion ? 0 : 200);
      };
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-popup-close]')) {
          closePopup(e.target.closest('[data-popup]'));
        } else if (e.target.hasAttribute && e.target.hasAttribute('data-popup')) {
          closePopup(e.target); // tap outside the panel closes
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        $$('[data-popup].is-open', root).forEach(closePopup);
      });

      // Newsletter posted from a popup: Shopify reloads with ?customer_posted=true#<form id>. Re-open THAT popup so
      // the success message is seen, then never show the signup popups again on this device.
      var subscribed = false;
      try { subscribed = localStorage.getItem('pl_subscribed') === '1'; } catch (e) {}
      if (/[?&]customer_posted=true/.test(location.search)) {
        subscribed = true;
        try { localStorage.setItem('pl_subscribed', '1'); } catch (e) {}
        var postedForm = location.hash.length > 1 && root.querySelector(location.hash.replace(/[^#\w-]/g, ''));
        var postedPopup = postedForm && postedForm.closest('[data-popup]');
        if (postedPopup) { seen = {}; openPopup(postedPopup.getAttribute('data-popup')); }
      }
      if (subscribed) { seen.welcome = 1; seen.exit = 1; }

      if (root.getAttribute('data-welcome-enabled') === 'true' && !seen.welcome) {
        var delay = Math.max(15, parseInt(root.getAttribute('data-welcome-delay'), 10) || 15) * 1000;
        window.setTimeout(function () { openPopup('welcome'); }, delay);
      }
      if (root.getAttribute('data-exit-enabled') === 'true' && !seen.exit) {
        var exitArmed = false;
        window.setTimeout(function () { exitArmed = true; }, 15000);
        document.addEventListener('mouseout', function (e) {
          if (!exitArmed || seen.exit || seen.welcome) return;
          if (e.clientY <= 0 && e.relatedTarget == null) openPopup('exit');
        });
      }
      if (root.getAttribute('data-cart-enabled') === 'true' && !seen.cart) {
        var cartDelay = (parseInt(root.getAttribute('data-cart-delay'), 10) || 60) * 1000;
        window.setTimeout(function () {
          var countEl = $('[data-cart-inner]');
          var count = countEl ? parseInt(countEl.getAttribute('data-item-count') || '0', 10) : 0;
          if (count > 0) openPopup('cart');
        }, cartDelay);
      }
    });
  }

  /* ------------------------------------------------------------------
     Recommended for you — heading swap based on recently viewed
  ------------------------------------------------------------------ */
  /* No repeated products: lists marked [data-pl-dedupe="<limit>"] hide cards already shown higher up the page
     (any product card outside a dedupe list, the flagship product, the PDP product) and promote their hidden
     spare cards (data-pl-spare) to keep the row full. Lists are processed top to bottom. */
  function dedupeProducts() {
    var seen = {};
    $$('[data-product-card][data-product-id], [data-pl-shown-product]').forEach(function (c) {
      if (c.closest('[data-pl-dedupe]') || c.closest('[data-cart-drawer], .drawer, .search-modal')) return;
      seen[c.getAttribute('data-pl-shown-product') || c.getAttribute('data-product-id')] = 1;
    });
    var cur = $('[data-product-section][data-product-id]');
    if (cur) seen[cur.getAttribute('data-product-id')] = 1;
    $$('[data-pl-dedupe]').forEach(function (list) {
      var limit = parseInt(list.getAttribute('data-pl-dedupe'), 10) || 4, shown = 0;
      $$('.product-grid__item', list).forEach(function (li) {
        var card = $('[data-product-card]', li), id = card && card.getAttribute('data-product-id');
        var keep = shown < limit && !(id && seen[id]);
        li.hidden = !keep;
        if (keep) { shown++; if (id) seen[id] = 1; }
      });
      var host = list.closest('.shopify-section');
      if (host) host.hidden = shown === 0; // nothing new to show → no empty row
    });
  }

  function initRecommendedForYou(ctx) {
    // Server markup already shows a real fallback grid (fallback collection → Bestsellers → all products).
    // Upgrade: Shopify related recommendations for the most recently viewed product (or the seed product).
    // The grid and heading only change when recommendations actually return products.
    $$('[data-recommended-for-you]', ctx).forEach(function (el) {
      if (el.dataset.recBound) return; el.dataset.recBound = '1';
      var base = el.getAttribute('data-recs-base');
      var sectionId = el.getAttribute('data-section-id');
      var grid = $('[data-recommended-grid]', el);
      var heading = $('[data-recommended-heading]', el);
      if (!base || !sectionId || !grid || !window.fetch) return;
      var viewed = getRecentlyViewed();
      var seedId = viewed.length ? viewed[0].id : el.getAttribute('data-seed-product-id');
      if (!seedId) return;
      var headingText = viewed.length ? el.getAttribute('data-heading-viewed') : el.getAttribute('data-heading-routine');
      var run = function () {
        fetch(base + '?section_id=' + encodeURIComponent(sectionId) + '&product_id=' + encodeURIComponent(seedId) + '&limit=' + Math.min(10, (parseInt(el.getAttribute('data-limit'), 10) || 4) + 6) + '&intent=related')
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-recommendations-inner]');
            if (!inner || !inner.children.length) return; // keep the server-rendered fallback grid
            grid.innerHTML = inner.innerHTML;
            grid.setAttribute('data-pl-dedupe', el.getAttribute('data-limit') || '4');
            dedupeProducts();
            if (heading && headingText) heading.textContent = headingText;
            initReveal(grid);
            initWishlist(grid);
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); run(); } }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(el);
      } else { run(); }
    });
  }


  /* ------------------------------------------------------------------
     Campaign — live countdowns + automatic hide after the real end date
     [data-campaign-end]      → hidden once now > end (covers cached pages)
     [data-campaign-fallback] → shown once the campaign has ended
     [data-campaign-countdown]→ data-format="compact" (2d 4h 12m) or "units" (d/h/m/s boxes)
  ------------------------------------------------------------------ */
  var campaignTimer = null;
  function parseEnd(v) { var t = new Date(v).getTime(); return isNaN(t) ? null : t; }
  function endCampaignUI(root) {
    $$('[data-campaign-end]', root).forEach(function (el) {
      var end = parseEnd(el.getAttribute('data-campaign-end'));
      if (end === null || end > Date.now()) return;
      if (el.classList.contains('announcement__msg')) { el.remove(); return; }
      el.hidden = true;
      var host = el.parentNode;
      if (host) $$('[data-campaign-fallback]', host).forEach(function (f) { f.hidden = false; });
    });
    var bar = $('[data-announcement]');
    if (bar && !$('.announcement__msg.is-active', bar)) {
      var first = $('.announcement__msg', bar);
      if (first) { first.classList.add('is-active'); first.removeAttribute('aria-hidden'); }
      else if (bar.closest('.announcement')) bar.closest('.announcement').hidden = true;
    }
  }
  function tickCampaign() {
    var now = Date.now();
    var pad = function (n) { return String(n).padStart(2, '0'); };
    $$('[data-campaign-countdown]').forEach(function (el) {
      var end = parseEnd(el.getAttribute('data-campaign-countdown'));
      if (end === null || end <= now) { el.hidden = true; return; }
      var win = parseFloat(el.getAttribute('data-cd-window') || '0');
      if (win > 0 && end - now > win * 86400000) { el.hidden = true; return; }
      var s = Math.floor((end - now) / 1000);
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      if (el.getAttribute('data-format') === 'units') {
        var out = { d: d, h: h, m: m, s: sec };
        Object.keys(out).forEach(function (k) { var n = $('[data-cd="' + k + '"]', el); if (n) n.textContent = pad(out[k]); });
      } else {
        var txt = d > 0 ? d + 'd ' + h + 'h ' + m + 'm' : (h > 0 ? h + 'h ' + pad(m) + 'm' : m + 'm ' + pad(sec) + 's');
        var t = $('[data-cd-text]', el); if (t) t.textContent = txt;
      }
      el.hidden = false;
    });
    endCampaignUI(document);
  }
  function initCampaign(ctx) {
    endCampaignUI(ctx || document);
    tickCampaign();
    if (!campaignTimer && $('[data-campaign-countdown], [data-campaign-end]')) campaignTimer = window.setInterval(function () { if (!document.hidden) tickCampaign(); }, 1000);
  }

  /* ------------------------------------------------------------------
     Cart upsells — Shopify recommendations (complementary → related) for the first cart item,
     falling back to the server-rendered list (merchant collection → all products, never items in cart).
  ------------------------------------------------------------------ */
  var recsCache = {};
  function escapeHtml(str) { return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fetchRecs(base, productId, intent) {
    var key = productId + ':' + intent;
    if (recsCache[key]) return recsCache[key];
    recsCache[key] = fetch(base + '.json?product_id=' + encodeURIComponent(productId) + '&limit=10&intent=' + intent)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { delete recsCache[key]; return []; });
    return recsCache[key];
  }
  function upsellImageUrl(p) {
    // /recommendations/products.json returns featured_image as a URL string; be defensive about objects too.
    var pick = function (x) { return !x ? '' : (typeof x === 'string' ? x : (x.src || x.url || (x.preview_image && x.preview_image.src) || '')); };
    var img = pick(p.featured_image) || pick(p.images && p.images[0]) || pick(p.media && p.media[0]);
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    return img;
  }
  function upsellItemHtml(p) {
    var variants = p.variants || [];
    var v = variants.filter(function (x) { return x.available; })[0] || variants[0];
    if (!v) return '';
    var img = upsellImageUrl(p);
    var sep = img.indexOf('?') > -1 ? '&' : '?';
    var imgHtml = img ? '<img src="' + escapeHtml(img + sep + 'width=300') + '" srcset="' + escapeHtml(img + sep + 'width=150') + ' 150w, ' + escapeHtml(img + sep + 'width=300') + ' 300w" sizes="56px" alt="" loading="eager" decoding="async" width="300" height="375">' : '';
    var price = formatMoney(v.price);
    var pct = savePercent(v.compare_at_price, v.price);
    var badge = pct ? '<span class="badge badge--sale pl-save upsell__save">' + escapeHtml(saveLabel(pct)) + '</span>' : '';
    var compare = badge + (v.compare_at_price && v.compare_at_price > v.price
      ? '<s class="upsell__compare"><span class="visually-hidden">Regular price </span>' + escapeHtml(formatMoney(v.compare_at_price)) + '</s>' : '');
    var action;
    if (variants.length === 1) {
      action = '<form method="post" action="' + escapeHtml(PL.routes.cartAdd) + '" class="upsell__form" data-product-form>' +
        '<input type="hidden" name="id" value="' + v.id + '"><input type="hidden" name="quantity" value="1">' +
        '<button type="submit" class="btn btn--small btn--outline upsell__add" data-add-button aria-label="' + escapeHtml('Add ' + p.title + ' to cart, ' + price) + '">Add — ' + escapeHtml(price) + '</button></form>';
    } else {
      action = '<a href="' + escapeHtml(p.url) + '" class="btn btn--small btn--outline upsell__add" aria-label="' + escapeHtml('Choose options for ' + p.title + ', ' + price) + '">Choose — ' + escapeHtml(price) + '</a>';
    }
    return '<li class="upsell__item"><a href="' + escapeHtml(p.url) + '" class="upsell__media" tabindex="-1" aria-hidden="true">' + imgHtml + '</a>' +
      '<div class="upsell__info"><a href="' + escapeHtml(p.url) + '" class="upsell__title">' + escapeHtml(p.title) + '</a></div>' +
      '<div class="upsell__buy">' + compare + action + '</div></li>';
  }
  function initCartUpsell(ctx) {
    $$('[data-cart-upsell]', ctx).forEach(function (box) {
      if (box.dataset.upsellBound) return; box.dataset.upsellBound = '1';
      var base = box.getAttribute('data-recs-url');
      var pid = box.getAttribute('data-product-id');
      if (!base || !pid || !window.fetch) return;
      var exclude = (box.getAttribute('data-exclude') || '').split(',').filter(Boolean);
      var limit = parseInt(box.getAttribute('data-limit'), 10) || 3;
      var pick = function (list) {
        var ids = {};
        return list.filter(function (p) {
          var ok = p.available !== false && exclude.indexOf(String(p.id)) === -1 && !ids[p.id];
          ids[p.id] = 1; return ok;
        }).slice(0, limit);
      };
      fetchRecs(base, pid, 'complementary').then(function (list) {
        var items = pick(list);
        return items.length ? items : fetchRecs(base, pid, 'related').then(pick);
      }).then(function (items) {
        if (!items.length || !document.contains(box)) return; // keep server-rendered fallback
        var html = items.map(upsellItemHtml).join('');
        if (!html) return;
        var list = $('[data-upsell-list]', box), heading = $('[data-upsell-heading]', box);
        if (list) list.innerHTML = html;
        if (heading) heading.textContent = box.getAttribute('data-heading-recs') || heading.textContent;
        box.hidden = false;
        box.classList.add('upsell--recs');
      });
    });
  }

  /* ------------------------------------------------------------------
     Init + Theme editor support
  ------------------------------------------------------------------ */
  function init(ctx) {
    ctx = ctx || document;
    [
      initReveal, stripDemoOnLiveTheme, initDropdowns, initCampaign, initAnnouncements, initCountdowns,
      function (c) { $$('[data-product-section]', c).forEach(initProduct); },
      function (c) { $$('[data-recommendations]', c).forEach(initRecommendations); },
      initLazyVideos, initWishlist, initCarousels, initBeforeAfter, initBeautyQuiz, initPopups,
      initRecommendedForYou, initCartUpsell, trackRecentlyViewed, initRecentlyViewedRow, dedupeProducts
    ].forEach(function (fn) {
      try { fn(ctx); } catch (err) { if (window.console) console.error('[PrimeLux]', err); }
    });
  }

  // DEMO-ONLY sample reviews: belt-and-braces client-side guard. The server-side Liquid guard
  // (snippets/demo-reviews-active.liquid) already prevents rendering on the published theme; if a
  // [data-pl-demo] node ever reaches the live (main) theme outside the editor, remove it immediately.
  function stripDemoOnLiveTheme(ctx) {
    var S = window.Shopify || {};
    if (S.designMode) return;
    if (!S.theme || S.theme.role !== 'main') return;
    (ctx || document).querySelectorAll('[data-pl-demo]').forEach(function (el) { el.remove(); });
  }
  stripDemoOnLiveTheme();

  /* Trust panels (sections/trust-panels): native modal <dialog> = focus trap, Esc and inert page built in.
     Triggers are real policy links, so without JS (or without the panel) they simply navigate. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest && t.closest('[data-dialog-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-dialog-open'));
      if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
        e.preventDefault();
        dlg._plOpener = opener;
        dlg.showModal();
      }
      return;
    }
    if (t.closest && t.closest('[data-dialog-close]')) {
      var d = t.closest('dialog');
      if (d) d.close();
      return;
    }
    if (t.tagName === 'DIALOG' && t.classList.contains('pl-dialog')) t.close(); // backdrop click
  });
  document.addEventListener('close', function (e) {
    var d = e.target;
    if (d && d._plOpener && d.classList && d.classList.contains('pl-dialog')) { d._plOpener.focus(); d._plOpener = null; }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-drawer="cart"]')) openDrawer('cart');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-drawer="cart"]')) closeDrawer(true);
  });

  // Back/forward cache: refresh cart drawer so counts are accurate
  window.addEventListener('pageshow', function (e) { if (e.persisted && PL.cartType === 'drawer') refreshCart(); });

  PL.openDrawer = openDrawer;
  PL.closeDrawer = closeDrawer;
  PL.refreshCart = refreshCart;
  PL.formatMoney = formatMoney;
  window.PrimeLux = PL;
})();

/* v4 · swipe dots under mobile carousels so a partial next card + dots make the swipe obvious */
(function () {
  var SEL = '.product-grid--scroll, .v2-scroller, .v4-discover__grid, .v2-results__list';
  function setup(row) {
    if (row.dataset.plDots) return; row.dataset.plDots = '1';
    var items = Array.prototype.slice.call(row.children).filter(function (c) { return c.offsetParent !== null || c.getClientRects().length; });
    if (items.length < 2) return;
    var nav = document.createElement('div'); nav.className = 'pl-dots'; nav.setAttribute('aria-hidden', 'true');
    var dots = items.slice(0, 10).map(function (it, i) {
      var b = document.createElement('button'); b.type = 'button'; b.tabIndex = -1;
      b.addEventListener('click', function () { row.scrollTo({ left: it.offsetLeft - row.offsetLeft - (parseFloat(getComputedStyle(row).paddingLeft) || 0), behavior: 'smooth' }); });
      nav.appendChild(b); return b;
    });
    row.insertAdjacentElement('afterend', nav);
    var update = function () {
      nav.hidden = row.scrollWidth <= row.clientWidth + 2;
      var max = row.scrollWidth - row.clientWidth, i = 0;
      if (max > 0) i = Math.round((row.scrollLeft / max) * (dots.length - 1));
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    };
    var t = false; row.addEventListener('scroll', function () { if (t) return; t = true; requestAnimationFrame(function () { t = false; update(); }); }, { passive: true });
    window.addEventListener('resize', update); update();
  }
  function init() { document.querySelectorAll(SEL).forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
